import { render } from "./ProjectDetailView.vue?vue&type=template&id=1336ae1c"
import script from "./ProjectDetailView.vue?vue&type=script&lang=js"
export * from "./ProjectDetailView.vue?vue&type=script&lang=js"

import "./ProjectDetailView.vue?vue&type=style&index=0&id=1336ae1c&lang=css"

import exportComponent from "../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@17.4.2_vue@3.5.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__